export enum GDPRUserType {
    MERCHANT_ADMINS = "MERCHANT_ADMINS",
    SUPPLIER_ADMINS = "SUPPLIER_ADMINS",
    COMPANY_ADMINS = "COMPANY_ADMINS",
    COMPANY_AGREEMENT_OWNERS = "COMPANY_AGREEMENT_OWNERS",
}

export enum GDPRUserTypeApiParam {
    KITCHEN = "KITCHEN",
    SUPPLIER = "SUPPLIER",
    COMPANY = "COMPANY",
}

export const GDPR_USER_TYPE_TO_API_PARAM: Record<GDPRUserType, GDPRUserTypeApiParam> = {
    [GDPRUserType.MERCHANT_ADMINS]: GDPRUserTypeApiParam.KITCHEN,
    [GDPRUserType.SUPPLIER_ADMINS]: GDPRUserTypeApiParam.SUPPLIER,
    [GDPRUserType.COMPANY_ADMINS]: GDPRUserTypeApiParam.COMPANY,
    [GDPRUserType.COMPANY_AGREEMENT_OWNERS]: GDPRUserTypeApiParam.COMPANY,
}

